/* eslint-disable */
export enum FeatureFlagsEnum {
    DistributionCoverArtGenerator = 'D_CoverArtGenerator',
    MasteringStandardPlugin = 'P_MasteringStandardPlugin',
    MasteringStandardPluginALC = 'P_MasteringStandardPluginALC',
    LandrUltimateBundle = 'P_CrossStorePurchases',
    LandrSynthXPlugin = 'P_LandrSynthXPlugin',
}
